// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__2X-x4","copyright":"Footer_copyright__2i5Ft"};